<div class="row">
    <!-- <div class="col-lg-9 col-md-9"> -->
    <div class="col-lg col-md">
        <h2 class="texto">{{header?.titleCard}} - {{header?.ScreenType}}</h2>
    </div>
    <!-- <div class="col-lg-3 col-md-3">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb" style="background-color: transparent !important; font-size: 9px !important;">
                <li class="breadcrumb-item"><a class="noLinkCursor textoGeral">Home</a></li>
                <li class="breadcrumb-item"><a class="noLinkCursor textoGeral">{{header?.titleModule}}</a></li>
                <li class="breadcrumb-item" aria-current="page">
                    <a class="noLinkCursor textoGeral">{{header?.ScreenName}}</a></li>
            </ol>
        </nav>
    </div> -->
    <hr>
</div>